import { render, staticRenderFns } from "./CheckoutButtonCheckout.vue?vue&type=template&id=18e98fc4&"
import script from "./CheckoutButtonCheckout.vue?vue&type=script&lang=js&"
export * from "./CheckoutButtonCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports